"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS = void 0;
exports.WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS = {
    height: 100,
    width: 168,
};
